export default __webpack_public_path__ + "static/media/christmas.8fd11187.gif";